<div class="full-popup-head">
  <div class="full-popup-title flex"><em class="modal-title-icon icon-store"></em>{{ data.title }}</div>
  <button
    type="button"
    class="btn btn-header-button"
    (click)="onLockSale()"
    *ngIf="(storeView$ | async) && hasLockSalePermission() && data.mode === requestPageModesEnum.REQUEST_VIEW"
  >
    <em class="icon-lock-pos"></em>
    {{
      (storeView$ | async)?.saleStatus && (storeView$ | async)?.saleStatus === saleStatus.DISABLE
        ? 'Unlock Sale'
        : 'Lock Sale'
    }}
  </button>
  <ng-container *ngIf="storeView$ | async as store">
    <ng-container *appHasPermission="['store_terminate']">
      <button
        type="button"
        class="btn btn-header-button"
        *ngIf="!store.merchantInfo.storeProfile[0]?.terminateDate && data.mode === requestPageModesEnum.REQUEST_VIEW"
        (click)="onTerminateStore(store)"
      >
        <em class="icon-terminate"></em>Terminate Store
      </button>
    </ng-container>
    <button
      type="button"
      class="btn btn-header-button"
      *ngIf="data.mode === requestPageModesEnum.REQUEST_VIEW"
      (click)="showHistory(store)"
    >
      <em class="icon-history"></em>History
    </button>
  </ng-container>
  <div class="full-popup-close">
    <a aria-label="Close" class="close" (click)="onCancel()">
      <em class="icon-close"></em>
    </a>
  </div>
  <div class="clearfix"></div>
</div>
<div class="admin-form">
  <div class="info-header-container">
    <div class="info-header-item" *ngIf="status !== 'D'; else edit">
      <div class="info-header-label">
        <span>Store Status:</span>
      </div>
      <div class="info-header-value">
        <span [ngClass]="getColorStatus((storeView$ | async)?.status)" class="store-status">
          {{ 'STORE.STATUS.' + (storeView$ | async)?.status | translate }}
        </span>
      </div>
    </div>
    <ng-template #edit>
      <div class="info-header-item">
        <div class="info-header-label">
          <span>Request Status:</span>
        </div>
        <div class="info-header-value">
          <span [ngClass]="getColorStatus('draft')" class="store-status">
            {{ 'STORE_REQUEST.STATUS.' + status | translate }}
          </span>
        </div>
      </div>
    </ng-template>
  </div>

  <app-merchant-info-bar
    [merchantName]="(storeView$ | async)?.merchantName"
    [taxId]="(storeView$ | async)?.taxId"
  ></app-merchant-info-bar>

  <div class="tab-menu d-flex d-inline-flex">
    <ng-container *ngFor="let tab of storeTabList">
      <a
        class="list-tab-menu px-3 px-md-5 py-2"
        [ngClass]="{ active: isSelectedTab | pureFn: tab.value : selectedTab }"
        (click)="onSelectTabs(tab.value)"
      >
        {{ tab.label }}
      </a>
    </ng-container>
  </div>

  <div [formGroup]="storeForm" [ngClass]="{ 'display-none': selectedTab !== StoreTabs.STORE_PROFILE }">
    <!-- Store Profile -->
    <div class="row section-header justify-content-between">
      <span>Store Profile</span>
    </div>
    <app-store-profile-version2
      #storeProfile
      [parentForm]="storeForm"
      [submitted]="submitted"
      [mode]="data.mode"
      [page]="storePage"
    ></app-store-profile-version2>

    <hr class="section-divider" />
    <!-- Store Profile -->

    <!-- Store Contact -->
    <div class="row section-header justify-content-between">
      <span>Store Contact</span>
    </div>
    <app-store-contact
      #storeContact
      [parentForm]="storeForm"
      [submitted]="submitted"
      [mode]="data.mode"
      [page]="storePage"
    ></app-store-contact>
    <hr class="section-divider" />
    <!-- Store Contact -->

    <!-- Store Location -->
    <div class="row section-header justify-content-between">
      <span>Store Location</span>
    </div>
    <app-store-location
      #storeLocation
      [parentForm]="storeForm"
      [submitted]="submitted"
      [mode]="data.mode"
      [page]="storePage"
    ></app-store-location>
    <hr class="section-divider" />
    <!-- Store Location -->

    <!-- Store Condition -->
    <div class="row section-header">
      <span id="">Store Sale Restrictions</span>
    </div>
    <div class="sub-section-header">
      Products under the selected Store Sale Restrictions will not be ordered to this store.
    </div>
    <app-store-condition
      #storeCondition
      [parentForm]="storeForm"
      [submitted]="submitted"
      [mode]="data.mode"
      [page]="storePage"
    >
    </app-store-condition>

    <hr class="section-divider" />
    <!-- Store Condition -->
    <div class="row section-header">
      <span id="ORDER_POLICY" data-id="ORDER_POLICY">Order Schedule</span>
    </div>
    <app-table-order-schedule [page]="storePage"></app-table-order-schedule>
  </div>
  <app-store-device
    [ngClass]="{ 'display-none': selectedTab !== StoreTabs.STORE_DEVICE }"
    [data]="data"
    [version]="version"
  >
  </app-store-device>
  <!--footer-->
  <ng-container *ngIf="hasAtLeastOnePermission()">
    <ng-container *ngIf="requestPageModesEnum.REQUEST_EDIT === data.mode; else otherMode">
      <div class="fixed-row-bottom form-row">
        <div class="float-right" *ngIf="hasSubmitPermission()">
          <button type="button" id="btn-cancel" class="btn btn-standard mr-2" (click)="onCancel()">Cancel</button>
          <button type="button" id="btn-submit" class="btn btn-primary" (click)="onSubmit()">Submit</button>
        </div>
      </div>
    </ng-container>
    <ng-template #otherMode>
      <ng-container>
        <div class="fixed-row-bottom form-row">
          <div class="float-left"></div>
          <div class="float-right">
            <span *ngIf="hasEditPermission() && (storeView$ | async)?.status !== requestStatus.INACTIVE" class="mr-2">
              <button type="button" id="btn-edit" class="btn btn-primary" (click)="onTriggerEdit()">Edit</button>
            </span>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </ng-container>
</div>

<app-terminate-store #terminateStoreModal (doAfterTerminate)="doAfterTerminate()"></app-terminate-store>
